import { Dispatch } from 'redux'

import { getFilesItem, saveFile } from '@/app/module/files/store/actions'
import { createNotification } from '@/app/module/notifications/store/actions'
import request from '@/app/module/request'
import { HTTPError } from '@/app/service/util/http'
import { FileType } from '@/app/types'
import http from '@/config/http'

import {
  getFileFailure,
  getFileRequest,
  getFileSuccess,
  saveFileFailure,
  saveFileRequest,
  saveFileSuccess,
} from './phone-number-files.slice'

export const onError =
  ({ message }: { message: string }) =>
  (dispatch: Dispatch) => {
    dispatch(
      createNotification({
        'save-hooks': {
          type: 'error',
          message,
        },
      }),
    )
  }

export const getPhonenumbersFile =
  ({ token, orgId, msgId, file }: { token: string; orgId: number; msgId: string; file: string }) =>
  (dispatch: Dispatch) => {
    dispatch(getFileRequest({ id: msgId, file }))

    return getFilesItem({ token, orgId, name: file })(dispatch)
      .then((res: FileType | Error) => {
        if (res instanceof Error) {
          throw res
        }
        dispatch(
          getFileSuccess({
            id: msgId,
            filename: file,
            url: res.url,
          }),
        )
        return res
      })
      .catch((err: HTTPError) => {
        dispatch(
          getFileFailure({
            id: msgId,
            status: err.status,
            message: err.message,
          }),
        )
        return err
      })
  }

export const savePhonenumbersFile =
  ({
    token,
    orgId,
    msgId,
    item,
  }: {
    token: string
    orgId: number
    msgId: string
    item: { filename?: string; title?: string; [k: string]: any }
  }) =>
  (dispatch: Dispatch) => {
    dispatch(saveFileRequest({ id: msgId }))

    return saveFile({
      token,
      orgId,
      item: { ...item },
    })(dispatch)
      .then((res: FileType | Error) => {
        if (res instanceof Error) {
          throw res
        }
        const dlPath = http.files.get.getSignablePath({ orgId, name: res.filename })
        const data = { paths: [dlPath] }
        return Promise.all([res, dlPath, (request as any).auth.sign({ token, item: data })])
      })
      .then(([{ filename, title }, signedPath, signedRes]: [FileType, string, Record<string, string>]) => {
        const result = {
          id: msgId,
          filename,
          title,
          url: http.files.get.getPath({
            signedPath,
            urlToken: signedRes[signedPath],
          }),
        }

        dispatch(saveFileSuccess(result))
        return result
      })
      .catch((err: HTTPError) => {
        dispatch(
          saveFileFailure({
            id: msgId,
            status: err.status,
            message: err.message,
          }),
        )
        return err
      })
  }
